<!-- Footer -->
<div appGsapReveal [y]="20" class="md:hidden fixed bottom-2 left-4 right-4 z-[60] mb-[env(safe-area-inset-bottom)]">
    <ion-tab-bar class="bg-white/70 backdrop-blur shadow-2xl rounded-full h-16 px-2 border-none overflow-hidden">
      <app-tabs-admin
        [notificationNumber]="newNotifications"
        *ngIf="role == roles_enums.ADMIN"
        class="w-full h-full"
      />

      <app-tabs-carrier
        [notificationNumber]="newNotifications"
        *ngIf="role == roles_enums.CARRIER"
        class="w-full h-full"
      />

      <app-tabs-company
        [notificationNumber]="newNotifications"
        *ngIf="role == roles_enums.COMPANY"
        class="w-full h-full"
      />
    </ion-tab-bar>
</div>

